export default "__VITE_ASSET__kgr$$u7g__"